export default {
  lead_modal: {
    title: '📩 Verifică prețul și disponibilitatea',
    subtitle:
      'Prețul și disponibilitatea se pot schimba. Lasă datele tale — un agent va confirma condițiile actuale.',

    name: 'Numele tău',
    contact: 'Număr WhatsApp',
    message: 'Mesaj (opțional)',

    cancel: 'Anulează',
    submit: 'Trimite',
    sending: 'Se trimite…',

    success: 'Cererea a fost trimisă!',
    error_unknown: 'Eroare necunoscută'
  }
}
